import reporter from 'redux-reporter'

const eventQueue = []

const flush = () => {
  if (window._satellite && eventQueue.length > 0) {
    eventQueue.splice(0).forEach(({ type, payload }) => {
      try {
        window._satellite.fireEvent('push', { type, payload })
      } catch (err) {
        //
      }
    })
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('load', flush)
}

export default reporter(
  ({ type, payload }) => {
    try {
      if (window._satellite) {
        flush()
        window._satellite.fireEvent('push', { type, payload })
      } else {
        eventQueue.push({ type, payload })
      }
    } catch (err) {
      //
    }
  },
  ({ meta = {} }) => meta.analytics
)
